import { Plan } from "../Plan/PlanModel";

export class SoulDataModel {
  userId?: string;
  email?: string | null;
  fullName?: string;
  role?: string;
  plan?: Plan;
  documentType?: string;
  passport?: string | null;
  address?: string;
  birthDate?: string;
  isParentAccount?: boolean;
  createdAt?: string;
  submission?: {
    id: string;
    json: any;
    finishedAt: string;
    updatedAt: string;
    submittedAt: string;
  };
  latestForm?: {
    id: string;
    json: any;
    createdAt: Date;
  };

  constructor(data: any) {
    data = data ?? {};
    this.fullName = data?.fullName || "Anónimo";
    this.role = data?.role;
    this.documentType = data?.documentType;
    this.passport = data?.passport ?? null;
    this.address = data?.address;
    this.email = data?.email ?? null;
    this.birthDate = data?.birthDate;
    this.isParentAccount = data?.isParentAccount || false;
    this.plan = data?.plan;
    this.userId = data?.userId;
    this.createdAt = data?.createdAt?.toString();
    if (data?.submission) {
      const sub = data.submission;
      this.submission = {
        id: sub.id || null,
        json: sub.json || null,
        finishedAt: sub.finishedAt || null,
        updatedAt: sub.updatedAt || null,
        submittedAt: sub.submittedAt || null,
      };
    }
    if (data?.latestForm) {
      const lf = data.latestForm;
      this.latestForm = {
        id: lf.id,
        json: lf.json || null,
        createdAt: lf.createdAt,
      };
    }
  }
}

export class UpdateSoulInfoPayload {
  payload?: SoulDataModel;
  submissionId?: string;

  constructor(payload?: SoulDataModel, submissionId?: string) {
    this.payload = payload;
    this.submissionId = submissionId;
  }
}
